import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Commande à table',
    [ORDER_METHODS.PICKUP]: 'À emporter',
    [ORDER_METHODS.DELIVERY]: 'Livraison',
  },
};
